
import httpClient from "@/plugins/axios";

export const getGroups = async () => {
    const response = await httpClient.get(`/v1/tenant/groups/`);
    return response;
}

export const getGroupMembers = async (groupId, page, pageSize) => {
    const response = await httpClient.get(`/v1/tenant/groups/${groupId}/members/?admin_view=1&page=${page}&page_size=${pageSize}`);
    return response;
}

export const getGroupAdmins = async (groupId, page, pageSize) => {
    const response = await httpClient.get(`/v1/tenant/groups/${groupId}/admins/?admin_view=1&page=${page}&page_size=${pageSize}`);
    return response;
}